import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="container-custom py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-file-list-3-line text-lg"></i>
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">
                Superbuy <span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              An independent educational resource platform providing research guides, spreadsheet organization methods, comparison tools, and shopping information.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-wider">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <a href="#categories" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">Product Categories</a>
              <a href="#guides" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">Featured Guides</a>
              <a href="#articles" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">Latest Articles</a>
              <a href="#comparison" className="text-foreground-400 hover:text-background-50 text-sm transition-colors cursor-pointer">Comparison</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm uppercase tracking-wider">External Resources</h4>
            <nav className="flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
              >
                Superbuy Sheet Main Site
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer"
              >
                Buy It Now
              </a>
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved. We are an independent educational platform.
          </p>
          <p className="text-foreground-500 text-xs">
            Not affiliated with any official Superbuy entity. External links open in new tabs.
          </p>
        </div>
      </div>
    </footer>
  );
}